









































import { Component, Vue, Mixins } from 'vue-property-decorator'
import { Action } from 'vuex-class'
import { SEND_LOGIN_REQUEST } from '@/system/store/action-types'
import { IActionType } from '@/system/store'
import { ICredentials } from '@/features/auth/store'
import { CHOOSE_CUSTOMER_NAME } from '@/features/auth/auth.router'
import { authLocalisationKeys } from '@/features/auth/auth.localisation'

import Notification from '@/shared/Notification.mixin.vue'
import { CheckRoleGuard } from '@/features/auth/auth.router.guards'

@Component
export default class Login extends Mixins(Notification) {
  private username: string | null = ''
  private password: string | null = ''
  private isPwd: boolean = true
  private translations = authLocalisationKeys

  get passwordValidationRules (): Function[] {
    return [
      (val: any) => (val !== null && val !== '') || this.$t(this.translations.EMPTY_PASSWORD),
      (val: any) => !(val.length < 6 || val.length > 20) || this.$t(this.translations.PASSWORD_LENGTH_ERROR)
    ]
  }

  get usernameValidationRules (): Function[] {
    return [(val: any) => (val && val.length > 0) || this.$t(this.translations.EMPTY_LOGIN)]
  }

  @Action(SEND_LOGIN_REQUEST) login!: IActionType<ICredentials>

  public async onSubmit (): Promise<void> {
    const { username, password } = this
    try {
      await this.login({ username, password } as ICredentials)

      this.$router.push({ name: CHOOSE_CUSTOMER_NAME })
    } catch (ex) {
      this.showError(this.$t(this.translations.INVALID_CREDENTIALS) as string)
    }
  }

  public onReset () {
    this.username = null
    this.password = null
  }
}
